import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthSessionService } from './auth-session.service';

export const LOCAL_PREVIEW_AUTH_HEADER = 'X-Saadospankki-Local-Preview';
export const LOCAL_PREVIEW_AUTH_BYPASS_ENABLED = new InjectionToken<boolean>(
  'LOCAL_PREVIEW_AUTH_BYPASS_ENABLED',
  {
    providedIn: 'root',
    factory: () => environment.localPreviewAuthBypass,
  },
);

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (!isProtectedApiRequest(request.url)) return next(request);
  const session = inject(AuthSessionService);
  const previewRequest = inject(LOCAL_PREVIEW_AUTH_BYPASS_ENABLED)
    ? request.clone({ setHeaders: { [LOCAL_PREVIEW_AUTH_HEADER]: '1' } })
    : request;
  const token = isSessionVerificationRequest(request.url)
    ? session.idToken()
    : session.whenReady().then(() => session.idToken());
  return from(token).pipe(
    switchMap((token) =>
      next(
        token
          ? previewRequest.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : previewRequest,
      ),
    ),
  );
};

export function isProtectedApiRequest(url: string): boolean {
  const parsed = new URL(url, globalThis.location?.origin ?? 'http://localhost');
  const currentOrigin = globalThis.location?.origin;
  if (currentOrigin && parsed.origin !== currentOrigin) return false;
  return parsed.pathname === '/api/v1' || parsed.pathname.startsWith('/api/v1/');
}

function isSessionVerificationRequest(url: string): boolean {
  const parsed = new URL(url, globalThis.location?.origin ?? 'http://localhost');
  return parsed.pathname === '/api/v1/auth/me';
}
